// Static site config for Nexaverve Solutions
export const SITE = {
  name: "Nexaverve Solutions",
  shortName: "Nexaverve",
  domain: "nexaverve.uk",
  email: "hello@nexaverve.uk",
  phoneDisplay: "+44 7599 698616",
  whatsappNumber: "447599698616", // E.164 without +
  whatsappPretty: "07599 698616",
  instagramHandle: "nexaverve.uk",
  instagramUrl: "https://www.instagram.com/nexaverve.uk",
  location: "Manchester · North West UK",
  established: "2025",
};

export const CONSULTANCY_SERVICES = [
  {
    code: "C01",
    title: "Cleaning Services",
    body: "Consulting and delivery across the cleaning verticals we know best.",
    bullets: [
      "Commercial Cleaning",
      "After Builders Cleaning",
      "End of Tenancy Cleaning",
    ],
  },
  {
    code: "C02",
    title: "Maintenance Services",
    body: "Keep your sites running with reactive fixes and planned upkeep.",
    bullets: [
      "Small Maintenance",
      "PAT Testing",
    ],
  },
  {
    code: "C03",
    title: "Compliance & H&S",
    body: "Documentation, audits and policies that hold up to scrutiny.",
    bullets: [
      "Risk Assessments",
      "Method Statements",
      "Compliance Reviews",
    ],
  },
  {
    code: "C04",
    title: "Operational Support",
    body: "Project-based consultancy to tighten how your teams hire, onboard and operate.",
    bullets: [
      "Recruitment processes",
      "Staff onboarding",
      "Policies & procedures",
      "Process improvement",
    ],
  },
];

export const CLEANING_SERVICES = [
  {
    code: "K01",
    title: "End of Tenancy",
    body: "Deposit-back deep cleans for landlords, agents and tenants across Greater Manchester.",
  },
  {
    code: "K02",
    title: "After Builders",
    body: "Post-construction cleaning, dust removal and sparkle finishes — ready for handover, occupation or opening.",
  },
  {
    code: "K03",
    title: "Commercial & Educational Cleaning",
    body: "Reliable cleaning services for schools, academies, offices, hospitality venues and commercial premises. Flexible support tailored to your operational needs.",
  },
];

export const PROCESS_STEPS = [
  {
    n: "01",
    title: "Discovery Call",
    body: "A quick consultation to scope the property, services and timeline you need.",
  },
  {
    n: "02",
    title: "Site Assessment",
    body: "We visit (or review remotely), price transparently and lock in a clear plan.",
  },
  {
    n: "03",
    title: "Delivery",
    body: "Our vetted team executes — with photos, sign-off sheets and compliance docs.",
  },
  {
    n: "04",
    title: "Aftercare",
    body: "Snag-list resolution, recurring schedules and ongoing compliance reviews.",
  },
];

export const STATS = [
  { value: "100%", label: "Insured & Vetted" },
  { value: "24h", label: "Avg. Quote Turnaround" },
  { value: "5+", label: "Service Verticals" },
  { value: "NW UK", label: "Coverage Area" },
];
